export default __webpack_public_path__ + "static/media/Ficha_Ourmed-2.14565b10.png";